import { SMSContact } from '../core/sms';
export default {
    RenderScene: new SMSContact(),
    DebugScene: new SMSContact(),
};
//# sourceMappingURL=contacts.js.map